import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject} from "rxjs";

import {
  PAGE_CONFIG,
  SEARCH_CONSTANT,
  SEARCH_BY_AADHAR,
} from "../constant/generic.constant";
import { IN_GeneralReq } from "../Interface/generic.interface";
@Injectable({
  providedIn: "root",
})
export class GenericService {
  constructor(private http: HttpClient) {}
  searchByPhoneorName(payload: IN_GeneralReq) {
    return this.http.post(
      `${SEARCH_CONSTANT.SEARCH_BY_PHONE_OR_NAME}`,
      payload
    );
  }
  public getUserBySearch(payload: IN_GeneralReq) {
    return this.http.post(`${SEARCH_BY_AADHAR.QUICK_SEARCH}`,
      payload
    );
  }
  public getPageConfig() {
    return this.http.get(PAGE_CONFIG.GENERIC_SEARCH_LIST);
  }

  public addGenericVisitor(obj) {
    return this.http.post(`${SEARCH_CONSTANT.ADD}`, obj);
  }

  public updateGenericVisitor(obj) {
    return this.http.put(`${SEARCH_CONSTANT.UPDATE}/${obj.id}`, obj);
  }

  messageSource: BehaviorSubject<object> = new BehaviorSubject<object>({});
  sendData(data: any, compId: number) {
    this.messageSource.next({ id: compId, data: data });
  }

  dynamicSource: BehaviorSubject<object> = new BehaviorSubject<object>({});
  sendDynamicData(data: any) {
    this.dynamicSource.next({ data: data });
  }
}
